module.exports = __webpack_public_path__ + "static/media/pose.de952717.jpg";